import { ENVIRONMENT_URL, DATAVERSE_TABLES } from '../constants/dataverse';

const environmentUrl = ENVIRONMENT_URL;

/** Normalize bakeries record to fronts-like shape for summary/cycle logic */
function normalizeBakeriesRecord(item: any): any {
  if (!item) return item;
  const normalized = { ...item };
  if (item.cr3ea_status !== undefined) normalized.cr3ea_criteria = item.cr3ea_status;
  if (item.cr3ea_majordefect !== undefined) normalized.cr3ea_defectremarks = item.cr3ea_majordefect;
  if (item.cr3ea_packaged !== undefined) normalized.cr3ea_pkd = item.cr3ea_packaged;
  if (item.cr3ea_itemno !== undefined) {
    normalized.cr3ea_evaluationtype = `Item ${item.cr3ea_itemno}`;
    normalized.cr3ea_packno = `Item ${item.cr3ea_itemno}`;
  }
  return normalized;
}

export type FetchCycleDetailsOptions = { tableName?: string };

export async function fetchCycleDetails(
  accessToken: string,
  plantTourId: string,
  options?: FetchCycleDetailsOptions
) {
  if (!accessToken || !plantTourId) {
    console.error("Missing access token or plant tour ID");
    return null;
  }

  const apiVersion = "9.2";
  const tableName = options?.tableName === DATAVERSE_TABLES.PQI_BAKERIES ? DATAVERSE_TABLES.PQI_BAKERIES : DATAVERSE_TABLES.PQI_FRONTS;
  const apiUrl = `${environmentUrl}/api/data/v${apiVersion}/${tableName}?$filter=cr3ea_qualitytourid eq '${plantTourId}'`;
  const isBakeries = tableName === DATAVERSE_TABLES.PQI_BAKERIES;

  const header = {
    Accept: "application/json",
    "Content-Type": "application/json; charset=utf-8",
    "OData-MaxVersion": "4.0",
    "OData-Version": "4.0",
    Authorization: `Bearer ${accessToken}`,
  };

  try {
    const response = await fetch(apiUrl, { headers: header });
    if (!response.ok) throw new Error("Error fetching cycle details");
    const responseData = await response.json();
    const value = responseData.value || [];
    if (isBakeries && value.length > 0) {
      return value.map(normalizeBakeriesRecord);
    }
    return value;
  } catch (error) {
    console.error("Error loading cycle details:", error);
    return [];
  }
}
